module.exports = __webpack_public_path__ + "assets/img/4-1.126a3637.jpg";